export default {
  NTE_PAGE_ACCESS_DENIED:
    'You do not appear to be an authorized user for this application. If you  believe you have received this message in error, please contact the administrator via email: {0}',

  NTE_ADMIN_REMOVE_ACCESS_TEXT_CONFIRM:
    'Are you sure you want to delete use "{0}"?',

  NTE_STRUCTURE_ID:
    'All passengers must be essential to the flight being performed and /or have Manager/Supervisor approval on the flight.',

  NTE_BRIEF_DESCRIPTION:
    'Please provide type of data collection (photo, LiDAR, IR, etc…), Drone make/model and upload a kmz, pdf, jpg, etc… file depicting the flight area.',

  NTE_ATTACH_FILE_ASSOCIATED_WITH_STRUCTURES:
    'Please attach the file associated with the structure IDs',
  NTE_ATTACH_FILE_FLIGHT_AREA_1: 'ATTACH SCREEN PRINT OF AREA TO BE FLOWN HERE',
  NTE_ATTACH_FILE_FLIGHT_AREA_2:
    '(i.e. google maps image or GIS Screen Cap in .jpg or .pdf or .png format)',
  NOTE_IF_YES_APPROVAL:
    'If yes, please attach the approval form from the summary screen',
  NOTE_IF_YES_LAND_APPROVAL:
    'If yes, please attach the Land Management Access permit',
  NOTE_IF_YES_ENVIRONMENTAL_APPROVAL:
    'If yes, please upload Environmental/Cultural Release',
  NTE_UPLOAD_SUPPORT_DOCUMENT: 'If yes, please upload supporting documents',
  NTE_AVIATION_SERVICE_ADMIN:
    'This section will be filled by the aviation team',
  NTE_ASSESSMENT_INFORMATION:
    "Missing value for this section, Mitigation If no mitigations then write 'No Mitigations'",
  NTE_REQUEST_STATUS_CHANGE_1:
    'This flight does not have a flight number associated with it. In order to generate a flight number, you must change the flight status to "In Flight".',
  NTE_REQUEST_STATUS_CHANGE_2:
    'Are you sure you would like to proceed with marking this flight as completed without a flight number?',
  NTE_FILE_TYPE_RESTRICION: 'Upload a file of type: ',
};
